export default __webpack_public_path__ + "static/media/ursinebrawl4.1996020d.png";